'use strict';

/**
 * Shared client helpers for recycle / promo coupon codes (UA|CH|HY).
 * Used by cart source-code form and checkout gift-card wallet Apply.
 */

var RECYCLE_CODE_LENGTH = 22;

/**
 * Whether the value is a complete recycle / promo coupon (UA|CH|HY + 16 body chars).
 * Prefix alone is not enough — source codes may also start with UA/CH/HY.
 * @param {string} raw - User-entered code
 * @returns {boolean} True when the compact value is a full recycle code
 */
function isRecycleCouponCode(raw) {
    var compact = String(raw || '').replace(/[^A-Za-z0-9]/g, '').toUpperCase();
    return /^(UA|CH|HY)[A-Z0-9]{16}$/.test(compact);
}

/**
 * Whether a value should be treated as recycle while typing.
 * Supports partial recycle prefixes to format early (U/UA, C/CH, H/HY).
 * @param {string} raw - Current input value
 * @returns {boolean} True when the value looks like a recycle code being typed
 */
function isRecycleLikeInput(raw) {
    var compact = String(raw || '').replace(/[^A-Za-z0-9]/g, '').toUpperCase();
    if (!compact) {
        return false;
    }
    return /^(U|UA|C|CH|H|HY)/.test(compact);
}

/**
 * Formats recycle values to `XX-XXXX-XXXX-XXXX-XXXX`.
 * Example: `UAUYNI...` => `UA-UYNI-LMA4-6BVH-V5GA`.
 * @param {string} raw - Current input value
 * @returns {string} Formatted recycle value
 */
function formatRecycleCodeValue(raw) {
    var compact = String(raw || '').replace(/[^A-Za-z0-9]/g, '').toUpperCase();
    if (!compact) {
        return '';
    }
    var prefix = compact.slice(0, 2);
    if (!/^(UA|CH|HY)$/.test(prefix)) {
        return compact;
    }

    // Max 18 alphanumeric chars: 2-char prefix + 4 groups of 4
    compact = compact.slice(0, 18);
    var body = compact.slice(2);
    var parts = [prefix];
    for (var i = 0; i < body.length; i += 4) {
        parts.push(body.slice(i, i + 4));
    }
    return parts.join('-');
}

/**
 * Applies recycle formatting in-place when needed.
 * @param {HTMLElement|jQuery|string} inputOrValue - input element, jQuery input, or raw string
 * @returns {string|null} Formatted value (or null when an element wasn't recyclable)
 */
function applyRecycleFormatIfNeeded(inputOrValue) {
    var $input = null;
    var rawValue;

    if (typeof inputOrValue === 'string') {
        // Selector-style strings should read/write the actual input element value.
        if ((inputOrValue.charAt(0) === '#' || inputOrValue.charAt(0) === '.')
            && $(inputOrValue).length) {
            $input = $(inputOrValue).first();
            rawValue = $input.val();
        } else {
            rawValue = inputOrValue;
        }
    } else {
        $input = $(inputOrValue);
        rawValue = $input.val();
    }

    if (!isRecycleLikeInput(rawValue)) {
        return null;
    }

    var formatted = formatRecycleCodeValue(rawValue);
    if ($input && $input.length) {
        $input.val(formatted);
    }
    return formatted;
}

module.exports = {
    RECYCLE_CODE_LENGTH: RECYCLE_CODE_LENGTH,
    isRecycleCouponCode: isRecycleCouponCode,
    isRecycleLikeInput: isRecycleLikeInput,
    formatRecycleCodeValue: formatRecycleCodeValue,
    applyRecycleFormatIfNeeded: applyRecycleFormatIfNeeded
};
